<template>
    <v-row
        :class="[
            newCampaign.campaign_type_system !== 'multiple_times_execution' &&
                'flex-column justify-center align-center'
        ]"
    >
        <v-col
            v-if="newCampaign.campaign_type_system !== 'repeat_execution'"
            cols="12"
            sm="12"
            :md="calendarMaxWidth"
            class="calendar-col"
        >
            <div class="mx-auto" style="max-width: 400px">
                <v-date-picker
                    v-model="dates"
                    multiple
                    offset-y
                    full-width
                    no-title
                    dark
                    reactive
                    elevation="16"
                    :locale="locale"
                    :min="new Date().toISOString()"
                    @click:date="chooseTime(dates.length - 1, true)"
                ></v-date-picker>
            </div>
        </v-col>

        <v-col
            cols="12"
            sm="12"
            md="8"
            class="d-flex flex-column datetimes-col"
            :style="datetimeColStyle"
        >
            <div v-if="newCampaign.campaign_type_system !== 'repeat_execution'">
                <div
                    v-for="(date, i) in dates"
                    :key="i"
                    class="d-flex flex-row align-center px-5"
                    :class="[
                        newCampaign.campaign_type_system !==
                            'multiple_times_execution' && 'justify-center'
                    ]"
                >
                    <v-dialog
                        transition="dialog-bottom-transition"
                        ref="dateDialogs"
                        v-model="dateDialogIsOpen[i]"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                style="max-width:350px"
                                class="px-3"
                                v-model="localizedDates[i]"
                                label=""
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :value="localizeDate(date)"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dates[i]"
                            scrollable
                            reactive
                            :locale="locale"
                            dark
                            :min="new Date().toISOString()"
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                @click="$set(dateDialogIsOpen, i, false)"
                            >
                                {{ translations.cancel[lang] }}
                            </v-btn>
                            <v-btn
                                text
                                @click="$refs.dateDialogs[i].save(date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>

                    <v-dialog
                        v-if="dateTimes[i]"
                        transition="fab-transition"
                        ref="timeDialog"
                        v-model="timeDialogIsOpen[i]"
                        :return-value.sync="dateTimes[i].time"
                        persistent
                        width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                class="px-3"
                                style="max-width:150px"
                                v-model="dateTimes[i].time"
                                label=""
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>

                        <v-time-picker
                            v-if="timeDialogIsOpen[i]"
                            reactive
                            v-model="dateTimes[i].time"
                            full-width
                            dark
                            class="campaign-timepicker"
                        >
                            <v-spacer></v-spacer>
                            <v-btn text @click="cancelTimeDialog(i)">
                                {{ translations.cancel[lang] }}
                            </v-btn>
                            <v-btn text @click="saveTimeDialog(i)">
                                OK
                            </v-btn>
                        </v-time-picker>
                    </v-dialog>
                    <div
                        @click="deleteDate(i)"
                        class="deleteDateTime d-flex justify-center align-center"
                    >
                        <span>x</span>
                    </div>
                </div>
            </div>
            <v-row v-else>
                <v-col cols="12" sm="12" md="6" class="mt-2">
                    <v-row>
                        <v-col
                            cols="12"
                            md="12"
                            class="d-flex justify-center pa-5 pb-0 mt-2"
                        >
                            <!-- <span class="text-center text-h5">{{
                                            translations.chooseDates[lang]
                                        }}</span> -->
                        </v-col>
                    </v-row>
                    <v-row class="mt-1 d-flex flex-column">
                        <v-col cols="12" lg="9">
                            <v-menu
                                v-model="fromDateMenu"
                                :close-on-content-click="false"
                                max-width="290"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="localizeDate(startDate)"
                                        clearable
                                        outlined
                                        dense
                                        :label="
                                            translations.from[lang] +
                                                translations.date[lang]
                                        "
                                        hide-details="auto"
                                        readonly
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click:clear="startDate = ''"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    dark
                                    v-model="startDate"
                                    :locale="locale"
                                    :min="new Date().toISOString()"
                                    @change="fromDateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-checkbox
                            :class="[!startDate && 'invisible']"
                            v-model="hasEndDate"
                            class="ml-3 mt-0 mb-n3 transition-all"
                            color="secondary"
                        >
                            <template v-slot:label>
                                <span
                                    class=" text-subtitle-1 font-weight-medium"
                                >
                                    {{ translations.hasEndDate[lang] }}
                                </span>
                            </template>
                        </v-checkbox>
                        <v-col
                            cols="12"
                            lg="9"
                            :class="[!hasEndDate && 'invisible']"
                            class="transition-all"
                        >
                            <v-menu
                                v-model="toDateMenu"
                                :close-on-content-click="false"
                                max-width="290"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="localizeDate(endDate)"
                                        clearable
                                        :label="
                                            translations.to[lang] +
                                                translations.date[lang]
                                        "
                                        hide-details="auto"
                                        readonly
                                        prepend-inner-icon="mdi-calendar"
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                        @click:clear="endDate = ''"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    dark
                                    v-model="endDate"
                                    :locale="locale"
                                    @change="toDateMenu = false"
                                    :min="minEndDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="d-flex flex-column">
                    <v-row>
                        <v-col
                            cols="12"
                            sm="12"
                            class="d-flex flex-row  justify-center align-center"
                        >
                            <v-checkbox
                                v-model="allDays"
                                @click="selectAllDays"
                                class=""
                            >
                                <template v-slot:label>
                                    <span
                                        class="ml-auto text-subtitle-1 font-weight-medium"
                                    >
                                        {{ translations.selectAll[lang] }}
                                    </span>
                                </template>
                            </v-checkbox>
                        </v-col>
                        <v-col
                            sm="12"
                            md="6"
                            v-for="(day, i) in dates"
                            :key="i"
                            class="d-flex flex-row align-center px-5 justify-center"
                            :order="(!i && 'last') || ''"
                        >
                            <v-col
                                cols="12"
                                sm="12"
                                style="max-width: 300px;"
                                class="d-flex flex-row  justify-center align-center ml-n6"
                            >
                                <v-checkbox
                                    v-model="day.value"
                                    class="ml-auto"
                                    color="#1bbae1"
                                >
                                    <template v-slot:label>
                                        <span
                                            v-if="day.name"
                                            class="ml-auto text-subtitle-1 font-weight-medium"
                                        >
                                            {{ translations[day.name][lang] }}
                                        </span>
                                    </template>
                                </v-checkbox>
                                <v-dialog
                                    v-if="dateTimes[i]"
                                    transition="fab-transition"
                                    ref="timeDialog"
                                    v-model="timeDialogIsOpen[i]"
                                    :return-value.sync="dateTimes[i].time"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            class="d-flex justify-center align-center"
                                        >
                                            <v-text-field
                                                class="px-3 d-flex justify-center align-center"
                                                style="max-width:150px"
                                                v-model="dateTimes[i].time"
                                                label=""
                                                prepend-icon="mdi-clock-time-four-outline"
                                                readonly
                                                outlined
                                                dense
                                                color="#1bbae1"
                                                :background-color="
                                                    (day.value &&
                                                        '#1bbae130') ||
                                                        undefined
                                                "
                                                hide-details
                                                :disabled="!day.value"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </div>
                                    </template>

                                    <v-time-picker
                                        v-if="timeDialogIsOpen[i]"
                                        reactive
                                        v-model="dateTimes[i].time"
                                        full-width
                                        dark
                                        class="campaign-timepicker"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            @click="cancelTimeDialog(i)"
                                        >
                                            {{ translations.cancel[lang] }}
                                        </v-btn>
                                        <v-btn text @click="saveTimeDialog(i)">
                                            OK
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-col>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import {
    mdiArrowLeft,
    mdiArrowRight,
    mdiCalendarMonth,
    mdiClockOutline
} from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import moment from "moment";
import translations from "@/utils/translations/loyaltyPanel/campaigns/newCampaign";
import newCampaign from "../../../store/modules/loyaltyPanel/campaigns/newCampaign";

export default {
    name: "Step2Informative",

    mixins: [translations],

    data: () => ({
        icons: {
            mdiArrowLeft,
            mdiArrowRight,
            mdiCalendarMonth,
            mdiClockOutline
        },
        deleteOnCancel: false,
        startTime: new Date().getHours() + ":" + new Date().getMinutes(),
        timeDialogIsOpen: [],
        dateDialogIsOpen: [],
        dates: [],
        dateTimes: [],
        times: ["", "", "", "", "", "", ""],
        fromDateMenu: false,
        toDateMenu: false,
        startDate: "",
        endDate: "",
        hasEndDate: false,
        allDays: false
    }),

    computed: {
        ...mapState("loyaltyPanel/campaigns/newCampaign", [
            "canGoToNextStep",
            "step"
        ]),
        lang() {
            return this.$route.params.lang;
        },
        locale() {
            if (this.lang == "el") return "el-GR";
            if (this.lang == "it") return "it-IT";
            return "en-GB";
        },

        campaignTypes() {
            const data = this.$store.state.loyaltyPanel.campaigns.newCampaign
                .campaignTypes;

            Array.from(data).forEach(dataName => {
                if (dataName.name === "One time execution") {
                    dataName.nameTranslation = this.translations.singleExecution[
                        this.lang
                    ];
                }
                if (dataName.name === "Repeat execution") {
                    dataName.nameTranslation = this.translations.repeatExecution[
                        this.lang
                    ];
                }
                if (dataName.name === "New transaction action") {
                    dataName.nameTranslation = this.translations.newTransactionAction[
                        this.lang
                    ];
                }
                if (dataName.name === "Transactions goal action") {
                    dataName.nameTranslation = this.translations.transactionsGoal[
                        this.lang
                    ];
                }
                if (dataName.name === "Transaction with specific products") {
                    dataName.nameTranslation = this.translations.transactionsProducts[
                        this.lang
                    ];
                }
            });
            const newData = [];
            newData[0] = { header: this.translations.informative[this.lang] };
            if (data[0]) {
                newData.push(data[0]);
            }
            if (data[1]) {
                newData.push(data[1]);
            }
            newData.push({
                header: this.translations.basedOnUserActions[this.lang]
            });
            newData.push({ divider: true });
            if (data[2]) {
                newData.push(data[2]);
            }
            if (data[3]) {
                newData.push(data[3]);
            }
            if (data[4]) {
                newData.push(data[4]);
            }
            return newData;
        },
        calendarMaxWidth() {
            if (this.dateTimes.length) return 4;
            return 12;
        },
        datetimeColStyle() {
            if (this.dateTimes.length)
                return { "max-width": "100%", float: "right", padding: 0 };
            return { "max-width": "0", float: "right", padding: 0 };
        },
        localizedDates() {
            return this.dates.map(date => this.localizeDate(date));
        },

        newCampaign: {
            get() {
                return this.$store.state.loyaltyPanel.campaigns.newCampaign
                    .newCampaign;
            },
            set(val) {
                this.setNewCampaign(val);
            }
        },
        minEndDate() {
            return this.startDate
                ? moment(this.startDate)
                      .add(1, "days")
                      .format("YYYY-MM-DD")
                : undefined;
        }
    },

    methods: {
        ...mapMutations("loyaltyPanel/campaigns/newCampaign", [
            "setNewCampaign",
            "setCanGoToNextStep"
        ]),
        chooseTime(i, cancelDelete = false) {
            this.deleteOnCancel = cancelDelete;
            if (
                this.newCampaign.campaign_type_system !==
                "multiple_times_execution"
            ) {
                while (i > 0) {
                    this.dates.shift();
                    i--;
                }
            }
            this.$set(this.timeDialogIsOpen, i, true);
        },
        selectAllDays() {
            if (this.newCampaign.campaign_type_system == "repeat_execution") {
                this.$nextTick(() => {
                    this.dates.forEach(e => (e.value = this.allDays));
                });
            }
        },
        localizeDate(date) {
            return date
                ? new Date(date).toLocaleString(this.locale, {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric"
                  })
                : "";
        },

        deleteDate(i) {
            this.dates.splice(i, 1);
            this.deleteOnCancel = false;
        },

        saveTimeDialog(i) {
            this.$refs.timeDialog[i].save(this.dateTimes[i]?.time);
            this.$set(this.timeDialogIsOpen, i, false);
            this.deleteOnCancel = false;
        },

        cancelTimeDialog(i) {
            this.$set(this.timeDialogIsOpen, i, false);
            if (this.deleteOnCancel) this.deleteDate(i);
        },

        goToNextStep() {
            this.$emit("next");
        },
        checkStepValidity() {
            this.setCanGoToNextStep(false);
            if (
                this.newCampaign.campaign_type_system ==
                "multiple_times_execution"
            ) {
                this.newCampaign.campaign_type_id_options = this.dateTimes;
                this.setCanGoToNextStep(!!this.dateTimes?.length);
            } else if (
                this.newCampaign.campaign_type_system == "repeat_execution"
            ) {
                let daytimes = [];
                this.setCanGoToNextStep(false);
                if (this.startDate) {
                    this.dateTimes.forEach((e, i) => {
                        daytimes.push((e.date.value && e.time) || "");
                        if (e.date.value) {
                            this.setCanGoToNextStep(!!e.time);
                        }
                    });
                }
                this.newCampaign.campaign_type_id_options = {
                    repeat_day_times: daytimes,
                    start_date: this.startDate,
                    end_date: this.endDate || undefined
                };
            } else if (
                this.newCampaign.campaign_type_system == "one_time_execution"
            ) {
                this.newCampaign.campaign_type_id_options = this.dateTimes[0];
                this.setCanGoToNextStep(!!this.dateTimes?.length);
            }
        }
    },

    watch: {
        dates: {
            handler(val) {
                this.dateTimes = val.reduce((a, c) => {
                    let dateTime = this.dateTimes.find(x => x.date == c);
                    if (!dateTime || !dateTime.date) {
                        return [
                            ...a,
                            {
                                date: c,
                                time:
                                    this.newCampaign.campaign_type_system ==
                                    "repeat_execution"
                                        ? ""
                                        : new Date(
                                              moment()
                                                  .add(1, "hours")
                                                  .format("YYYY-MM-DD HH:mm:ss")
                                          ).toLocaleTimeString("el-GR", {
                                              hour12: false,
                                              hour: "2-digit",
                                              minute: "2-digit"
                                          }) + ""
                            }
                        ];
                    }
                    return [...a, { ...dateTime }];
                }, []);
                if (
                    this.newCampaign.campaign_type_system == "repeat_execution"
                ) {
                    this.allDays = true;
                    this.dates.forEach(e => {
                        this.allDays = this.allDays && e.value;
                    });
                }
            },
            deep: true
        },

        dateTimes: {
            handler(val) {
                this.checkStepValidity();
            },
            deep: true
        },

        startDate: {
            handler(val) {
                if (!val || (this.endDate && this.endDate <= val)) {
                    this.hasEndDate = false;
                }
                this.checkStepValidity();
            }
        },

        endDate: {
            handler(val) {
                this.checkStepValidity();
            }
        },

        hasEndDate: {
            handler(val) {
                if (!val) this.endDate = "";
            }
        },

        step: {
            handler(val) {
                if (val == 2 && this.newCampaign.category == "informative") {
                    this.checkStepValidity();
                }
            }
        },

        ["newCampaign.campaign_type_system"]: {
            handler(val) {
                this.setCanGoToNextStep(false);
                // while(this.dates.length>1){
                //     this.dates.shift()
                // }
                this.dates = [new Date().toISOString().substring(0, 10)];
                if (
                    this.newCampaign.campaign_type_system == "repeat_execution"
                ) {
                    this.dates = [
                        { name: "sunday", value: false },
                        { name: "monday", value: false },
                        { name: "tuesday", value: false },
                        { name: "wednesday", value: false },
                        { name: "thursday", value: false },
                        { name: "friday", value: false },
                        { name: "saturday", value: false }
                    ];
                }
            },
            immediate: true
        }
    },

    mounted() {
        if (this.newCampaign.campaign_type_id_options.date) {
            this.dates = [this.newCampaign.campaign_type_id_options.date];
            this.dateTimes = [{ ...this.newCampaign.campaign_type_id_options }];
        } else if (this.newCampaign.campaign_type_id_options.length) {
            this.dates = this.newCampaign.campaign_type_id_options.map(
                e => e.date
            );
            this.dateTimes = [...this.newCampaign.campaign_type_id_options];
        } else if (
            this.newCampaign.campaign_type_id_options.repeat_day_times?.length
        ) {
            this.startDate =
                this.newCampaign.campaign_type_id_options.start_date || "";
            this.endDate =
                this.newCampaign.campaign_type_id_options.end_date || "";
            this.dateTimes = this.dates.map((e, i) => {
                let time =
                    this.newCampaign.campaign_type_id_options
                        ?.repeat_day_times?.[i] || "";
                e.value = !!time;
                return {
                    date: e,
                    time
                };
            });
        } else {
            this.dates = [new Date().toISOString().substring(0, 10)];
        }
        if (this.newCampaign.campaign_type_system == "repeat_execution") {
            this.dates = [
                { name: "sunday", value: false },
                { name: "monday", value: false },
                { name: "tuesday", value: false },
                { name: "wednesday", value: false },
                { name: "thursday", value: false },
                { name: "friday", value: false },
                { name: "saturday", value: false }
            ];
        }
        this.checkStepValidity();
    }
};
</script>
<style scoped>
.deleteDateTime {
    cursor: pointer;
    padding: 1px 8px 3px 8px;
    margin-bottom: 15px;
    border-radius: 15px;
}
.deleteDateTime:hover {
    font-weight: 550;
    background-color: rgba(0, 0, 0, 0.2);
}
.calendar-col {
    transition: all 0.5s ease-in-out;
}
.datetimes-col {
    transition: all 0.8s ease-in-out;
}

.transition-all {
    transition: all 1s, width 2s, max-width 1s, min-width 1s, margin-left 2s,
        margin-top 2.5s, background-position 1.5s, opacity 1s;
}
.invisible {
    opacity: 0;
    z-index: 0;
}
</style>
<style>
.campaign-timepicker .primary--text {
    color: #1bbae1 !important;
}
.campaign-timepicker .v-picker__title__btn--active {
    font-weight: 600 !important;
}
</style>
